
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/auth/login",
      function () {
        return require("private-next-pages/[market]/[language]/auth/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/auth/login"])
      });
    }
  